import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RetailerAuthContext = createContext(null);

export function RetailerAuthProvider({ children }) {
  const [retailer, setRetailer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("retailerToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      fetchRetailerProfile();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchRetailerProfile = async () => {
    try {
      const response = await axios.get(`${API}/retailer/me`);
      setRetailer(response.data);
    } catch (error) {
      console.error("Failed to fetch retailer profile:", error);
      localStorage.removeItem("retailerToken");
      delete axios.defaults.headers.common["Authorization"];
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/retailer/login`, { email, password });
    const { token, retailer: retailerData } = response.data;
    localStorage.setItem("retailerToken", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setRetailer(retailerData);
    return retailerData;
  };

  const register = async (data) => {
    const response = await axios.post(`${API}/retailer/register`, data);
    const { token, retailer: retailerData } = response.data;
    localStorage.setItem("retailerToken", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setRetailer(retailerData);
    return retailerData;
  };

  const logout = () => {
    localStorage.removeItem("retailerToken");
    delete axios.defaults.headers.common["Authorization"];
    setRetailer(null);
  };

  return (
    <RetailerAuthContext.Provider value={{ retailer, loading, login, register, logout, fetchRetailerProfile }}>
      {children}
    </RetailerAuthContext.Provider>
  );
}

export function useRetailerAuth() {
  const context = useContext(RetailerAuthContext);
  if (!context) {
    throw new Error("useRetailerAuth must be used within a RetailerAuthProvider");
  }
  return context;
}
